import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-form-add",
  "use": "icon-form-add-usage",
  "viewBox": "0 0 198.4 198.4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 198.4 198.4\" id=\"icon-form-add\">\r\n<path d=\"M54.1,0h90.2c29.9,0,54.1,24.2,54.1,54.1v90.2c0,29.9-24.2,54.1-54.1,54.1l0,0H54.1C24.2,198.4,0,174.2,0,144.3V54.1\r\n\tC0,24.2,24.2,0,54.1,0L54.1,0z M54.1,14.4c-21.9,0-39.7,17.8-39.7,39.7v90.2c0,21.9,17.8,39.7,39.7,39.7h0h90.2\r\n\tc21.9,0,39.7-17.8,39.7-39.7V54.1c0-21.9-17.8-39.7-39.7-39.7L54.1,14.4L54.1,14.4z\" />\r\n<path d=\"M106.4,54.1V92l37.9,0v14.4h-37.9v37.9H92l0-37.9H54.1V92L92,92l0-37.9H106.4z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/form/form-add.svg
// module id = /PiT
// module chunks = 13